import NewCreditCardForm from './NewCreditCardForm'

export default NewCreditCardForm
